import { PhoneCall, BadgeDollarSign, HandCoins, Phone } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { PHONE_DISPLAY, PHONE_TEL } from "../constants/content";

const IMG =
    "https://images.pexels.com/photos/10400836/pexels-photo-10400836.jpeg?auto=compress&cs=tinysrgb&w=940";

const STEPS = [
    {
        icon: PhoneCall,
        title: "Tell us about your ride",
        desc: `Call ${PHONE_DISPLAY} and give us the year, make, model and general condition of your vehicle.`,
    },
    {
        icon: BadgeDollarSign,
        title: "Accept our top-cash offer",
        desc: "We give you our highest competitive quote instantly over the phone — no haggling, no waiting.",
    },
    {
        icon: HandCoins,
        title: "Get paid cash on delivery",
        desc: "Our driver arrives, completes the ownership paperwork and hands you cash on the spot.",
    },
];

export const HowItWorks = () => (
    <section id="how-it-works" className="relative bg-white noise-overlay overflow-hidden">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-24 lg:py-32">
            <Reveal className="max-w-2xl">
                <Eyebrow>Selling your car — how it works</Eyebrow>
                <h2 className="mt-4 font-display font-extrabold uppercase tracking-tight text-2xl sm:text-3xl lg:text-4xl text-[#141721] leading-tight">
                    Three easy steps,{" "}
                    <span className="text-[#FF3B30]">and your car is sold.</span>
                </h2>
            </Reveal>

            <div className="mt-14 grid gap-6 lg:grid-cols-3">
                {STEPS.map((step, i) => (
                    <Reveal key={step.title} delay={i * 0.12}>
                        <div
                            data-testid={`how-step-${i}`}
                            className="group relative h-full rounded-lg border border-[#E3E3DE] bg-[#F4F4F2] p-8 transition-all duration-500 hover:border-[#FF3B30] hover:-translate-y-1.5"
                        >
                            <div className="flex h-12 w-12 items-center justify-center rounded-md bg-[#FF3B30]">
                                <step.icon className="h-6 w-6 text-white" strokeWidth={2.2} />
                            </div>
                            <span className="absolute top-7 right-7 font-mono-ind text-sm font-bold text-[#6B7280]">
                                0{i + 1}
                            </span>
                            <h3 className="mt-7 font-display font-bold text-xl text-[#141721] tracking-tight">
                                {step.title}
                            </h3>
                            <p className="mt-3 text-sm text-[#565B6B] leading-relaxed">{step.desc}</p>
                        </div>
                    </Reveal>
                ))}
            </div>

            <Reveal delay={0.2}>
                <div className="relative mt-14 overflow-hidden rounded-lg border border-[#E3E3DE]">
                    <img
                        src={IMG}
                        alt="Cash handed over for a scrap vehicle"
                        className="h-64 sm:h-80 w-full object-cover"
                    />
                    <div className="absolute inset-0 bg-white/60" />
                    <div className="absolute inset-0 flex flex-col items-center justify-center gap-5 px-6 text-center">
                        <p className="font-display font-extrabold uppercase tracking-tight text-2xl sm:text-3xl text-[#141721]">
                            That&apos;s it. Quick, easy, stress-free.
                        </p>
                        <a
                            href={PHONE_TEL}
                            data-testid="how-it-works-call-btn"
                            className="inline-flex items-center gap-3 rounded-md bg-[#FF3B30] px-8 py-4 font-display font-extrabold text-lg text-white uppercase tracking-wide transition-all duration-300 hover:bg-[#E0342B] hover:-translate-y-0.5"
                        >
                            <Phone className="h-5 w-5" strokeWidth={2.6} />
                            Call {PHONE_DISPLAY}
                        </a>
                    </div>
                </div>
            </Reveal>
        </div>
    </section>
);
